import { ErrorDetail } from '../../types';

export interface AD {
    host: string;
    port: number;
    base: string;
    group: Array<string>;
    ssl: string;
    admin_user: string;
    admin_password?: string;
    password_exist: boolean;
    enabled: boolean;
    import_mail_address: false;
}

export interface Domain {
    domain_name: string;
    enabled: boolean;
}

export interface Multifactor {
    status?: string;
    device_type?: string;
    enabled?: boolean;
    allowed_second?: number;
}

export interface SessionTimeout {
    enabled: boolean;
    minutes: number;
}

export interface PasswordPolicy {
    digit_from: number;
    digit_to: number;
    expiration_enabled: boolean;
    expiration_date: number;
    history_enabled: boolean;
    history: number;
}

export interface AccountLock {
    enabled: boolean;
    count: number;
    unlock?: 1 | 2 | 3;
    unlock_minutes: number;
    send_unlock_mail?: boolean;
}

export interface AccountExpiration {
    enabled: boolean;
    date: number;
}

export interface VerificationMail {
    enabled: boolean;
    expiration_date: number;
}

export interface OneTimePassword {
    hard_interval_second: number;
    soft_interval_second: number;
}

export interface PublicApi {
    accept_auth?: string;
    accept_ip_address: string;
}

export interface Saml {
    enabled: boolean;
    provider: string;
}

export interface Idp {
    site_url: string;
    certificate: string;
    login_url: string;
    issuer_url: string;
    import_mail_address: boolean;
}

export interface MicrosoftEntraId {
    tenant_id: string;
    application_id: string;
    client_secret: string;
    client_secret_exist: boolean;
}

export interface OneLogin {
    domain: string;
    application_id: string;
    client_id: string;
    client_secret: string;
    client_secret_exist: boolean;
}

export interface Okta {
    domain: string;
    application_id: string;
    token: string;
    token_exist: boolean;
}

export interface UserSetting {
    AD: AD;
    domain: Domain;
    multifactor: Multifactor;
    session_timeout: SessionTimeout;
    password_policy: PasswordPolicy;
    account_lock: AccountLock;
    account_expiration: AccountExpiration;
    verification_mail: VerificationMail;
    otp: OneTimePassword;
    public_api: PublicApi;
    saml: Saml;
    idp: Idp;
    microsoft_entra_id: MicrosoftEntraId;
    one_login: OneLogin;
    okta: Okta;
}

export interface UserSettingState {
    userSetting: UserSetting;
    show: {
        category?: string;
        isProcessing: boolean;
        isFetchSuccess: boolean;
        error: boolean;
        errorCode?: string;
        errorMsg?: string;
    };
    update: {
        category?: string;
        isProcessing: boolean;
        error: boolean;
        errorTitle?: string;
        errorDetails?: Array<ErrorDetail>;
    };
    beforeLogin: {
        isProcessing: boolean;
        error: boolean;
        errorCode?: string;
        errorMsg?: string;
    };
    connection: {
        isProcessing: boolean;
        error: boolean;
        errorTitle?: string;
        errorDetails?: Array<ErrorDetail>;
    };
    import: {
        isProcessing: boolean;
        error: boolean;
        errorTitle?: string;
        errorDetails?: Array<ErrorDetail>;
    };
    connectionIdp: {
        isProcessing: boolean;
        error: boolean;
        errorTitle?: string;
        errorDetails?: Array<ErrorDetail>;
    };
    importIdp: {
        isProcessing: boolean;
        error: boolean;
        errorTitle?: string;
        errorDetails?: Array<ErrorDetail>;
    };
}
export const IdPType = {
    TypeName: (idp_type: string): string => {
        let IdPName = '';
        if (IdPType.isMicrosoftEntraIdType(idp_type)) IdPName = 'MicrosoftEntraID';
        if (IdPType.isOneLoginType(idp_type)) IdPName = 'OneLogin';
        if (IdPType.isOktaType(idp_type)) IdPName = 'Okta';
        return IdPName;
    },
    isMicrosoftEntraIdType: (idp_type: string): boolean => {
        return idp_type === 'microsoftentraid';
    },
    isOneLoginType: (idp_type: string): boolean => {
        return idp_type === 'onelogin';
    },
    isOktaType: (idp_type: string): boolean => {
        return idp_type === 'okta';
    },
};
